export function resetModel(object: any): any {
  Object.keys(object).forEach((key: any) => {
    switch (typeof object[key]) {
      case 'object':
      case 'number':
        object[key] = null;
        break;
      case 'string':
        object[key] = '';
        break;
      case 'boolean':
        object[key] = false;
        break;
      default:
        object[key] = null;
    }
  });
  return object;
}

export function isObjectEmpty(object: any) {
  return Object.keys(object).length;
}
